import React from 'react'
import PanelHead from '../../Panel/PanelHead'
import PanelBody from '../../Panel/PanelBody'
import { FormEditShop } from './FormEditShop'

export const PanelEditShop = () => {
    return (
        <div>  <PanelHead title='Edit Advertising' />
            <PanelBody content={<FormEditShop />} />
        </div>


    )
}
